import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SplitPageLeft from './SplitPageLeft';
import MicrosoftSplitPageLeft from './MicrosoftSplitPageLeft';

import makeStyles from '@material-ui/core/styles/makeStyles';

function SplitPageContainer({ children, isMicrosoft = false }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classNames(classes.left, { [classes.newLeft]: isMicrosoft })}>
        {isMicrosoft ? <MicrosoftSplitPageLeft /> : <SplitPageLeft />}
      </div>
      <div className={classes.right}>{children}</div>
    </div>
  );
}

SplitPageContainer.propTypes = {
  children: PropTypes.object,
  isMicrosoft: PropTypes.bool,
};

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'row',
    fontStyle: 'normal',
    backgroundColor: '#ffffff',
  },
  left: {
    width: '40%',
    maxWidth: 600,
    background: 'linear-gradient(324deg, #431a6e, #813be1 92%, #773dbd)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  newLeft: {
    background: `linear-gradient(180deg, ${theme.palette.marketing.purples.deep}00 0%, ${
      theme.palette.marketing.purples.deep
    } 100%), ${theme.palette.marketing.purples.fig}`,
  },
  right: {
    width: '60%',
    maxWidth: 960,
    height: '100vh',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      alignText: 'center',
    },
  },
}));

export default SplitPageContainer;
